export default "__VITE_ASSET__DNw7IeXF__"